export default "__VITE_ASSET__bECvZzuu__"